import { Navigate, Outlet } from 'react-router-dom';
import { useApp } from '@context/AppContext';
import PageLayout from './PageLayout';
import { PublicRoutes } from '@enums/publicRouteEnums';

export default function ProtectedRoute() {
  const { isAuthorized, isAuthResolved } = useApp();

  // Stored auth is read asynchronously, so isAuthorized is false on the first
  // render even for a signed-in user. Redirecting here would replace the
  // requested URL with /login and lose it: AppContext then sends /login on to
  // "/", so every deep link landed on Overview instead of the target page.
  // Render nothing until auth is known - Suspense already covers this gap.
  if (!isAuthResolved) {
    return null;
  }

  if (!isAuthorized) {
    return <Navigate to={PublicRoutes.LOGIN} replace />;
  }

  return (
    <PageLayout>
      <Outlet />
    </PageLayout>
  );
}
